var _style, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHpLogoBlueRgb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 215.7 216",
    style: {
      enableBackground: "new 0 0 215.7 216"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#0096D6;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 216,
    height: 216
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66,164.8c-0.6,0-1.3,0-1.9,0l13.2-36.4h18.2c3.2,0,6.7-2.5,7.8-5.5l14.4-39.5c2.4-6.5-1.4-11.8-8.2-11.8H84.2 L63,130l0,0l-12,33.1C22.4,156.3,1.2,130.6,1.2,100c0-29.7,20-54.8,47.3-62.4L36.1,71.7l0,0l-20.6,56.7h13.7l17.5-48.2H57 l-17.5,48.2h13.7l16.4-44.9c2.4-6.5-1.3-11.8-8.2-11.8H49.8l13.3-36.4c1,0,1.9-0.1,2.9-0.1c35.8,0,64.8,29,64.8,64.8 S101.8,164.8,66,164.8z M105.2,80.2H94.9l-14.5,39.7h10.3L105.2,80.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHpLogoBlueRgb);
export default __webpack_public_path__ + "static/media/hp-logo-blue-rgb.69a1d8ffcbb1952db5ac17a9af406d9d.svg";
export { ForwardRef as ReactComponent };